
$(document).on('click', '.TRUSTeWidget_Tab_link', function () {
    if (!window['TRUSTeWidget']) {
        $.getScript('https://preferences.truste.com/webservices/js?domain=consumersunion.org&type=consumer', function () {
            window['TRUSTeWidget'].Tab.link();
        });
    } else {
        window['TRUSTeWidget'].Tab.link();
    }
    return false;
});



// WEBPACK FOOTER //
// ./resources/modules/shared/footer/footer.js